/**
 * 
 * @returns 获取随机颜色
 */
export const getRandomColor = () => {
  const colorList = [
    '#CEEDF0', '#81cfe3', '#F0B651', '#FC91AD', '#F04C37',
    '#409EFF', '#67C23A', '#909399', '#722ed1', '#13c2c2'
  ];
  let lastIndex = -1;
  return () => {
    let index;
    do {
      index = Math.floor(Math.random() * colorList.length);
    } while (index === lastIndex);
    lastIndex = index;
    return colorList[index];
  };
};